@if (loading()) {
  <div class="flex flex-col gap-2">
    <div class="h-25 flex flex-col w-full bg-surface-tertiary rounded-lg"></div>
    <div class="h-100 flex flex-col w-full bg-surface-tertiary rounded-lg"></div>
  </div>
} @else {
  @if (ticket(); as ticket) {
    <!--<div [softMeta]="meta" [softValue]="ticket" class="">
  <div *softMetaFieldName="'id'">{{ticket.id | metaFormat}}</div>
  <div *softMetaFieldName="'name'">{{ticket.name}}</div>
  <div *softMetaFieldName="'serviceLevelAgreement'">
    <div *softMetaFieldName="'id'">{{ticket.serviceLevelAgreement?.id}}</div>
    <div *softMetaFieldName="'description'">{{ticket.serviceLevelAgreement?.description}}</div>
  </div>
</div>-->
    <div class="grid gap-2 mb-2">
      <div class="text-lg font-bold">#{{ ticket.id }}</div>
      <div class="text-2xl font-bold">{{ ticket?.name }}</div>
      <div class="flex flex-row gap-1 flex-wrap">
        @if (!ticketConfig.isCustomer) {
          <soft-chip
            [color]="'primary'"
            [variant]="'outline'"
            [icon]="'fa-regular fa-user'"
          >
            {{
              ticket?.customer
                ? ticket?.customer?.number + ' - ' + ticket?.customer?.name
                : 'kein Kunde'
            }}</soft-chip
          >
          <soft-chip
            [color]="'primary'"
            [variant]="'outline'"
            [icon]="'fa-regular fa-hammer'"
          >
            {{
              ticket?.object
                ? ticket?.object?.number + '-' + ticket?.object?.name
                : 'kein Objekt'
            }}</soft-chip
          >
        }
        <soft-chip
          [color]="'primary'"
          [variant]="'outline'"
          [icon]="'fa-regular fa-calendar'"
        >
          {{ ($safeNavigationMigration(ticket?.created) | format: 'DATE.DEFAULT') || '-' }}</soft-chip
        >
        <soft-chip
          [color]="typeColor()"
          [variant]="'outline'"
          [icon]="'fa-regular fa-clipboard-list'"
        >
          {{ ticket?.type?.name || '-' }}</soft-chip
        >
        <soft-chip
          [color]="stateColor()"
          [variant]="'outline'"
          [icon]="'fa-regular fa-arrows-spin'"
        >
          Ticket
          {{ '#TICKETS.STATES.' + $safeNavigationMigration(ticket?.state) | uppercase | translate }}</soft-chip
        >
        <soft-chip
          [color]="stepColor()"
          [variant]="'outline'"
          [icon]="'fa-regular fa-arrows-spin'"
        >
          Workflow {{ ticket?.step }}</soft-chip
        >
      </div>

      <div class="flex flex-row bg-surface rounded p-3 opacity-80">
        <div class="g custom-grid">
          <!-- <div class="flex flex-col">
          <strong class="font-semibold">{{
            '#TICKETS.DETAILS.STATE' | translate
          }}</strong>
          <p class="font-light">
            {{ '#TICKETS.STATES.' + ticket?.state | uppercase | translate }}
          </p>
        </div> -->
          <!-- <div class="flex flex-col">
          <strong class="font-semibold">{{
            '#TICKETS.DETAILS.WORKFLOW_STATE' | translate
          }}</strong>
          <p class="font-light">{{ ticket?.step }}</p>
        </div> -->
          <!-- <div class="flex flex-col">
          <strong class="font-semibold">{{ '#TICKETS.DETAILS.TYPE' | translate }}</strong>
          <p class="font-light">{{ ticket?.type?.name || '-' }}</p>
        </div> -->
          <div class="flex flex-col">
            <strong class="font-semibold">{{
              '#TICKETS.DETAILS.PRIORITY' | translate
            }}</strong>
            <p class="font-light">{{ ticket?.priority }}</p>
          </div>
          <div class="flex flex-col">
            <strong class="font-semibold">{{
              '#TICKETS.DETAILS.CONTACT' | translate
            }}</strong>
            <p class="font-light">
              {{ ticket?.contact?.firstName }} {{ ticket?.contact?.lastName }}
            </p>
          </div>
          <div class="flex flex-col">
            <strong class="font-semibold">{{
              '#TICKETS.DETAILS.SLA' | translate
            }}</strong>
            <p class="font-light">
              {{ ticket?.serviceLevelAgreement?.description || '-' }}
            </p>
          </div>
          <div class="flex flex-col">
            <strong class="font-semibold">{{
              '#TICKETS.DETAILS.DUE' | translate
            }}</strong>
            <p class="font-light">
              {{ ($safeNavigationMigration(ticket?.deadline) | format: 'DATE.DEFAULT') || '-' }}
            </p>
          </div>
          <div class="flex flex-col">
            <strong class="font-semibold">{{
              '#TICKETS.DETAILS.CREATORS' | translate
            }}</strong>
            @if (ticket?.creators) {
              @for (creator of ticket?.creators; track creator.id) {
                <p class="font-light">{{ creator?.firstName }} {{ creator?.lastName }}</p>
              }
            }
            @if (!ticket?.creators) {
              <p class="font-light">-</p>
            }
          </div>
          <div class="flex flex-col">
            <strong class="font-semibold">{{
              '#TICKETS.DETAILS.CREATED' | translate
            }}</strong>
            <p class="font-light">
              {{ ($safeNavigationMigration(ticket?.created) | format: 'DATE_TIME.DEFAULT') || '-' }}
            </p>
          </div>
          <div class="flex flex-col">
            <strong class="font-semibold">{{
              '#TICKETS.DETAILS.ESTIMATED_TIME' | translate
            }}</strong>
            @if (ticket?.estimatedTimeMax) {
              <p class="font-light">
                @if (ticket?.estimatedTimeMin) {
                  {{ $safeNavigationMigration(ticket?.estimatedTimeMin) | format: 'DURATION.DEFAULT' }} -
                }
                {{ $safeNavigationMigration(ticket?.estimatedTimeMax) | format: 'DURATION.DEFAULT' }}
              </p>
            }
            @if (!ticket?.estimatedTimeMax) {
              <p class="font-light">-</p>
            }
          </div>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-2">
      @if (
        ticket.nextSteps &&
        (($safeNavigationMigration(ticket?.step) | in: orderConfirmationSteps) ||
          ($safeNavigationMigration(ticket?.step) | in: testConfirmationSteps))
      ) {
        <cdk-accordion>
          <cdk-accordion-item
            role="button"
            tabindex="0"
            #accordionItem="cdkAccordionItem"
            [attr.aria-expanded]="accordionItem.expanded"
          >
            <div
              class="flex justify-between items-center cursor-pointer rounded bg-surface p-1"
              [ngClass]="accordionItem.expanded ? 'rounded-b-none' : 'rounded'"
              (click)="accordionItem.toggle()"
            >
              <h4 class="text-lg font-bold">
                {{ '#TICKETS.DETAILS.HEADER.CONFIRMATION' | translate }}
              </h4>
              <div
                class="text-light bg-surface rounded-full p-3 cursor-pointer hover:bg-hover"
              >
                @if (!accordionItem.expanded) {
                  <soft-icon name="fa-regular fa-chevron-down"></soft-icon>
                }
                @if (accordionItem.expanded) {
                  <soft-icon name="fa-regular fa-chevron-up"></soft-icon>
                }
              </div>
            </div>
            <div
              class="flex flex-col"
              [style.display]="accordionItem.expanded ? 'block' : 'none'"
            >
              <div class="flex flex-col card">
                @if ($safeNavigationMigration(ticket?.step) | in: orderConfirmationSteps) {
                  @if (ticket.estimatedTimeMax !== 'PT0S') {
                    <strong>{{
                      '#TICKETS.DETAILS.CONFIRMATION.ORDER_1'
                        | translate
                        | interpolate
                          : { time: ticket.estimatedTimeMax | format: 'DURATION.DEFAULT' }
                    }}</strong>
                  }
                  @if (ticket.estimatedTimeMax === 'PT0S') {
                    <strong>{{
                      '#TICKETS.DETAILS.CONFIRMATION.ORDER_AT_COST' | translate
                    }}</strong>
                  }
                  <div class="mt-2">
                    {{ '#TICKETS.DETAILS.CONFIRMATION.ORDER_2' | translate }}
                  </div>
                }
                @if ($safeNavigationMigration(ticket?.step) | in: testConfirmationSteps) {
                  <strong>{{
                    '#TICKETS.DETAILS.CONFIRMATION.TEST_1' | translate
                  }}</strong>
                  <div class="mt-2">
                    {{ '#TICKETS.DETAILS.CONFIRMATION.TEST_2' | translate }}
                  </div>
                }
                <div class="flex flex-row mt-4">
                  @for (step of ticket?.nextSteps; track step) {
                    <button
                      type="submit"
                      class="soft-button soft-button-secondary mr-4"
                      (click)="dispatchNextStep({ ticketId: ticket.id, step: step })"
                    >
                      {{ step }}
                    </button>
                  }
                </div>
              </div>
            </div>
          </cdk-accordion-item>
        </cdk-accordion>
      }

      <cdk-accordion>
        <cdk-accordion-item
          role="button"
          tabindex="0"
          #accordionItemDesc="cdkAccordionItem"
          [attr.aria-expanded]="accordionItemDesc.expanded"
        >
          <div
            class="flex justify-between items-center cursor-pointer rounded bg-surface p-1"
            [ngClass]="accordionItemDesc.expanded ? 'rounded-b-none' : 'rounded'"
            (click)="accordionItemDesc.toggle()"
          >
            <h4 class="text-lg font-bold">
              {{ '#TICKETS.DETAILS.HEADER.DESCRIPTION' | translate }}
            </h4>
            <div class="flex">
              @if (accordionItemDesc.expanded) {
                <div
                  class="text-orange-500 bg-orange-300 rounded-full p-3 cursor-pointer hover:bg-hover"
                  (click)="updateDescription(); $event.stopPropagation()"
                  softToolTip="Beschreibung speichern"
                >
                  <soft-icon name="fa-regular fa-floppy-disk"></soft-icon>
                </div>
              }
              <div
                class="text-light bg-surface rounded-full p-3 cursor-pointer hover:bg-hover"
              >
                @if (!accordionItemDesc.expanded) {
                  <soft-icon name="fa-regular fa-chevron-down"></soft-icon>
                }
                @if (accordionItemDesc.expanded) {
                  <soft-icon name="fa-regular fa-chevron-up"></soft-icon>
                }
              </div>
            </div>
          </div>
          <section
            class="flex flex-col"
            [style.display]="accordionItemDesc.expanded ? 'block' : 'none'"
          >
            <div>
              <soft-rich-text-editor
                [content]="ticket.description"
                [autofocus]="false"
                (contentChange)="descriptionChanged($event)"
              ></soft-rich-text-editor>
            </div>
          </section>
        </cdk-accordion-item>
      </cdk-accordion>

      @if (ticket.analyseInfo) {
        <cdk-accordion>
          <cdk-accordion-item
            role="button"
            tabindex="0"
            #accordionItemAnalyse="cdkAccordionItem"
            [attr.aria-expanded]="accordionItemAnalyse.expanded"
          >
            <div
              class="flex justify-between items-center cursor-pointer rounded bg-surface p-1"
              [ngClass]="accordionItemAnalyse.expanded ? 'rounded-b-none' : 'rounded'"
              (click)="accordionItemAnalyse.toggle()"
            >
              <h4 class="text-lg font-bold">
                {{ '#TICKETS.DETAILS.HEADER.ANALYSE' | translate }}
              </h4>
              <div
                class="text-light bg-surface rounded-full p-3 cursor-pointer hover:bg-hover"
              >
                @if (!accordionItemAnalyse.expanded) {
                  <soft-icon name="fa-regular fa-chevron-down"></soft-icon>
                }
                @if (accordionItemAnalyse.expanded) {
                  <soft-icon name="fa-regular fa-chevron-up"></soft-icon>
                }
              </div>
            </div>
            <section
              class="flex flex-col card"
              [style.display]="accordionItemAnalyse.expanded ? 'block' : 'none'"
            >
              <div
                [innerHTML]="ticket.analyseInfo | replace: '\n' : '<br />' | secureHtml"
              ></div>
            </section>
          </cdk-accordion-item>
        </cdk-accordion>
      }

      @if (ticket.releaseInfo) {
        <cdk-accordion>
          <cdk-accordion-item
            role="button"
            tabindex="0"
            #accordionItemReleaseInfo="cdkAccordionItem"
            [attr.aria-expanded]="accordionItemReleaseInfo.expanded"
          >
            <div
              class="flex justify-between items-center cursor-pointer rounded bg-surface p-1"
              [ngClass]="accordionItemReleaseInfo.expanded ? 'rounded-b-none' : 'rounded'"
              (click)="accordionItemReleaseInfo.toggle()"
            >
              <h4 class="text-lg font-bold">
                {{ '#TICKETS.DETAILS.HEADER.RELEASE_INFO' | translate }}
              </h4>
              <div
                class="text-light bg-surface rounded-full p-3 cursor-pointer hover:bg-hover"
              >
                @if (!accordionItemReleaseInfo.expanded) {
                  <soft-icon name="fa-regular fa-chevron-down"></soft-icon>
                }
                @if (accordionItemReleaseInfo.expanded) {
                  <soft-icon name="fa-regular fa-chevron-up"></soft-icon>
                }
              </div>
            </div>
            <section
              class="flex flex-col card"
              [style.display]="accordionItemReleaseInfo.expanded ? 'block' : 'none'"
            >
              <div
                [innerHTML]="ticket.releaseInfo | replace: '\n' : '<br />' | secureHtml"
              ></div>
            </section>
          </cdk-accordion-item>
        </cdk-accordion>
      }

      @if (ticket?.type?.name === 'Release') {
        <cdk-accordion>
          <cdk-accordion-item
            role="button"
            tabindex="0"
            #accordionItemRelease="cdkAccordionItem"
            [attr.aria-expanded]="accordionItemRelease.expanded"
          >
            <div
              class="flex justify-between items-center cursor-pointer rounded bg-surface p-1"
              [ngClass]="accordionItemRelease.expanded ? 'rounded-b-none' : 'rounded'"
              (click)="accordionItemRelease.toggle()"
            >
              <h4 class="text-lg font-bold">
                {{ '#TICKETS.DETAILS.HEADER.RELEASE' | translate }}
              </h4>
              <div
                class="text-light bg-surface rounded-full p-3 cursor-pointer hover:bg-hover"
              >
                @if (!accordionItemRelease.expanded) {
                  <soft-icon name="fa-regular fa-chevron-down"></soft-icon>
                }
                @if (accordionItemRelease.expanded) {
                  <soft-icon name="fa-regular fa-chevron-up"></soft-icon>
                }
              </div>
            </div>
            <section
              class="flex flex-col card"
              [style.display]="accordionItemRelease.expanded ? 'block' : 'none'"
            >
              <div>
                <strong>Testsystem geplante Installation</strong>
                <div class="font-light">
                  {{
                    ticket?.release?.releasestart_beta ?? '-'
                      | format: 'DATE_TIME.DEFAULT'
                  }}
                  @if (ticket?.release?.releaseduration_beta) {
                    (Dauer:
                    {{
                      ($safeNavigationMigration(ticket?.release?.releaseduration_beta)
                        | format: 'DURATION.DEFAULT') ?? '-'
                    }})
                  }
                </div>
              </div>
              <div class="mt-3">
                <strong>Echtsystem geplante Installation</strong>
                <div class="font-light">
                  {{
                    ticket?.release?.releasestart_original ?? '-'
                      | format: 'DATE_TIME.DEFAULT'
                  }}
                  @if (ticket?.release?.releaseduration_original) {
                    (Dauer:
                    {{
                      ($safeNavigationMigration(ticket?.release?.releaseduration_original)
                        | format: 'DURATION.DEFAULT') ?? '-'
                    }})
                  }
                </div>
              </div>
            </section>
          </cdk-accordion-item>
        </cdk-accordion>
      }

      <cdk-accordion>
        <cdk-accordion-item
          role="button"
          tabindex="0"
          #accordionItemComment="cdkAccordionItem"
          [attr.aria-expanded]="accordionItemComment.expanded"
        >
          <div
            class="flex justify-between items-center cursor-pointer rounded bg-surface p-1"
            [ngClass]="accordionItemComment.expanded ? 'rounded-b-none' : 'rounded'"
            (click)="accordionItemComment.toggle()"
          >
            <h4 class="text-lg font-bold">
              {{ '#TICKETS.DETAILS.HEADER.COMMENTS' | translate }}
            </h4>
            <div
              class="text-light bg-surface rounded-full p-3 cursor-pointer hover:bg-hover"
            >
              @if (!accordionItemComment.expanded) {
                <soft-icon name="fa-regular fa-chevron-down"></soft-icon>
              }
              @if (accordionItemComment.expanded) {
                <soft-icon name="fa-regular fa-chevron-up"></soft-icon>
              }
            </div>
          </div>
          @if (comments$ | async; as comments) {
            @if (comments.length > 0) {
              <section
                class="card"
                [style.display]="accordionItemComment.expanded ? 'block' : 'none'"
              >
                <div class="flex flex-col gap-3">
                  @for (comment of comments; track comment.id) {
                    <div class="border-2 bg-surface rounded">
                      <div
                        class="flex items-center gap-2 bg-surface-secondary text-light font-bold"
                      >
                        <span class="p-3">
                          {{ comment?.contact?.firstName }}
                          {{ comment?.contact?.lastName }}
                        </span>
                        <span class="text-xs">
                          {{ $safeNavigationMigration(comment?.creationDate) | format: 'DATE_TIME.DEFAULT' }}
                        </span>
                        @if (comment.internal) {
                          <div
                            softToolTip="{{ '#TICKETS.DETAILS.INTERNAL' | translate }}"
                            class="text-light p-3"
                          >
                            <soft-icon name="fa-regular fa-eye-slash"></soft-icon>
                          </div>
                        }
                        <!--<span *ngIf="comment.contact.id">
                <i class="fa-regular fa-pen-to-square mr-4"></i>
                <i class="fa-regular fa-trash"></i>
              </span>-->
                      </div>

                      <div
                        class="p-3"
                        [innerHTML]="
                          $safeNavigationMigration(comment?.text) | replace: '\n' : '<br />' | secureHtml
                        "
                      ></div>
                    </div>
                  }
                  <div
                    softToolTip="Kommentar hinzufügen"
                    class="self-center text-primary bg-primary-50 rounded-full p-3 cursor-pointer hover:bg-hover"
                    (click)="onAddComment()"
                  >
                    <soft-icon name="fa-regular fa-plus"></soft-icon>
                  </div>
                </div>
              </section>
            } @else {
              <section
                class="card text-light flex-col items-center justify-center gap-1"
                [style.display]="accordionItemComment.expanded ? 'flex' : 'none'"
              >
                <soft-icon name="fa-regular fa-comment"></soft-icon>
                <div>Noch keine Kommentare</div>
                <div
                  softToolTip="Kommentar hinzufügen"
                  class="text-primary bg-primary-50 rounded-full p-3 cursor-pointer hover:bg-hover"
                  (click)="onAddComment()"
                >
                  <soft-icon name="fa-regular fa-plus"></soft-icon>
                </div>
              </section>
            }
          }
        </cdk-accordion-item>
      </cdk-accordion>

      <cdk-accordion>
        <cdk-accordion-item
          role="button"
          tabindex="0"
          #accordionItemContact="cdkAccordionItem"
          [attr.aria-expanded]="accordionItemContact.expanded"
        >
          <div
            class="flex justify-between items-center cursor-pointer rounded bg-surface p-1"
            [ngClass]="accordionItemContact.expanded ? 'rounded-b-none' : 'rounded'"
            (click)="accordionItemContact.toggle()"
          >
            <h4 class="text-lg font-bold">
              {{ '#TICKETS.DETAILS.HEADER.CONTACTS' | translate }}
            </h4>
            <div
              class="text-light bg-surface rounded-full p-3 cursor-pointer hover:bg-hover"
            >
              @if (!accordionItemContact.expanded) {
                <soft-icon name="fa-regular fa-chevron-down"></soft-icon>
              }
              @if (accordionItemContact.expanded) {
                <soft-icon name="fa-regular fa-chevron-up"></soft-icon>
              }
            </div>
          </div>
          @if (ticket?.contacts?.length) {
            <section
              class="flex flex-col card"
              [style.display]="accordionItemContact.expanded ? 'block' : 'none'"
            >
              @for (group of ticket.contacts | groupBy: 'type'; track group.key) {
                <div class="mb-8">
                  <div
                    class="flex items-center gap-1 text-primary bg-primary-50 border-2 border-primary rounded-full p-3"
                  >
                    <soft-icon name="fa-regular fa-user"></soft-icon>
                    <h5 class="font-bold">
                      {{ $any(group).key | contactType | translate }}
                    </h5>
                  </div>
                  <div class="soft-list p-x-3">
                    <!-- @for (contact of group | toArray; track contact.contact.id) { -->
                    @for (contact of group | toArray; track $any(contact).contact.id) {
                      <div class="soft-list-item flex items-center gap-1">
                        <a
                          href="mailto:{{
                            $any(contact).contact.email1 || $any(contact).contact.email2
                          }}"
                          softToolTip="E-Mail senden"
                          class="text-primary bg-primary-50 rounded-full p-3 cursor-pointer hover:bg-hover"
                        >
                          <soft-icon name="fa-regular fa-envelope"></soft-icon>
                        </a>
                        <div class="flex flex-col">
                          <span>
                            {{ $any(contact).contact.firstName }}
                            {{ $any(contact).contact.lastName }}
                          </span>
                          <span class="text-light">
                            {{
                              $any(contact).contact.email1 || $any(contact).contact.email2
                            }}
                          </span>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
            </section>
          } @else {
            <section
              class="card text-light flex-col items-center justify-center gap-1"
              [style.display]="accordionItemContact.expanded ? 'flex' : 'none'"
            >
              <soft-icon name="fa-regular fa-comment"></soft-icon>
              <div>Noch keine Teilnehmer</div>
              <div
                softToolTip="Teilnehmer hinzufügen"
                class="text-primary bg-primary-50 rounded-full p-3 cursor-pointer hover:bg-hover"
                (click)="onEditContacts()"
              >
                <soft-icon name="fa-regular fa-plus"></soft-icon>
              </div>
            </section>
          }
        </cdk-accordion-item>
      </cdk-accordion>

      <cdk-accordion>
        <cdk-accordion-item
          role="button"
          tabindex="0"
          #accordionItemDoc="cdkAccordionItem"
          [attr.aria-expanded]="accordionItemDoc.expanded"
        >
          <div
            class="flex justify-between items-center cursor-pointer rounded bg-surface p-1"
            [ngClass]="accordionItemDoc.expanded ? 'rounded-b-none' : 'rounded'"
            (click)="accordionItemDoc.toggle()"
          >
            <h4 class="text-lg font-bold">
              {{ '#TICKETS.DETAILS.HEADER.DOCUMENTS' | translate }}
            </h4>
            <div
              class="text-light bg-surface rounded-full p-3 cursor-pointer hover:bg-hover"
            >
              @if (!accordionItemDoc.expanded) {
                <soft-icon name="fa-regular fa-chevron-down"></soft-icon>
              }
              @if (accordionItemDoc.expanded) {
                <soft-icon name="fa-regular fa-chevron-up"></soft-icon>
              }
            </div>
          </div>
          @if (((documents$ | async)?.length ?? 0) > 0) {
            <section
              class="flex flex-col card"
              [style.display]="accordionItemDoc.expanded ? 'grid' : 'none'"
            >
              @for (document of documents$ | async; track document.id) {
                <div class="flex flex-row items-center gap-1">
                  <div class="font-semibold break-all">{{ document.name }}</div>
                  <span>&#8226;</span>
                  <span class="font-light">{{ document.size | filesize }}</span>
                  <div class="flex flex-row gap-1">
                    @if (document.file.name | isImage) {
                      <div
                        class="text-primary rounded-full p-3 cursor-pointer hover:bg-hover"
                        (click)="openImage(document.file)"
                        softToolTip="Bild öffnen"
                      >
                        <soft-icon name="fa-regular fa-eye"></soft-icon>
                      </div>
                    }
                    <div
                      class="text-primary rounded-full p-3 cursor-pointer hover:bg-hover"
                      (click)="downloadFile(document.file)"
                      softToolTip="Dokument herunterladen"
                    >
                      <soft-icon name="fa-regular fa-cloud-arrow-down"></soft-icon>
                    </div>
                  </div>
                </div>
              }
            </section>
          } @else {
            <section
              class="card text-light flex-col items-center justify-center gap-1"
              [style.display]="accordionItemDoc.expanded ? 'flex' : 'none'"
            >
              <soft-icon name="fa-regular fa-comment"></soft-icon>
              <div>Noch keine Dokumente</div>
              <div
                softToolTip="Dokument hinzufügen"
                class="text-primary bg-primary-50 rounded-full p-3 cursor-pointer hover:bg-hover"
                (click)="onUploadDocument()"
              >
                <soft-icon name="fa-regular fa-plus"></soft-icon>
              </div>
            </section>
          }
        </cdk-accordion-item>
      </cdk-accordion>
    </div>
  }
}

<ng-template #menuBarTemplate>
  <div class="grid grid-flow-col gap-1">
    <soft-menu-bar-button
      [variant]="'primary'"
      [icon]="'fa-regular fa-pen-to-square'"
      [responsive]="true"
      [label]="'Bearbeiten'"
      tooltip="Bearbeiten"
      (execute)="onEdit()"
    ></soft-menu-bar-button>
    <soft-menu-bar-button
      [variant]="'primary'"
      [icon]="'fa-regular fa-comment-plus'"
      [responsive]="true"
      [label]="'Kommentieren'"
      tooltip="Kommentar hinzufügen"
      (execute)="onAddComment()"
    ></soft-menu-bar-button>
    <soft-menu-bar-button
      [variant]="'primary'"
      [icon]="'fa-regular fa-users'"
      [responsive]="true"
      [label]="'Teilnehmer'"
      tooltip="Kontakte bearbeiten"
      (execute)="onEditContacts()"
    ></soft-menu-bar-button>
    <soft-menu-bar-button
      [variant]="'primary'"
      [icon]="'fa-regular fa-cloud-arrow-up'"
      [responsive]="true"
      [label]="'Upload'"
      tooltip="Dokument hochladen"
      (execute)="onUploadDocument()"
    ></soft-menu-bar-button>
    @if (!this.ticketConfig.isCustomer) {
      <soft-menu-bar-button
        [variant]="'outline'"
        [icon]="'fa-regular fa-id-badge'"
        [responsive]="true"
        tooltip="Ticket zuweisen"
        [disabled]="!editorPermission()"
        (execute)="onAssignTicket()"
      ></soft-menu-bar-button>
      <soft-menu-bar-button
        [variant]="'outline'"
        [icon]="'fa-regular fa-clipboard-list'"
        [responsive]="true"
        tooltip="Checkliste bearbeiten"
        [disabled]="!editorPermission()"
        (execute)="onEditCheckList()"
      ></soft-menu-bar-button>
      <soft-menu-bar-button
        [variant]="'outline'"
        [icon]="'fa-regular fa-clock'"
        [responsive]="true"
        tooltip="Zeiterfassung"
        [disabled]="!timeReportPermission()"
        (execute)="onEditTimeReport()"
      ></soft-menu-bar-button>
    }
    <soft-menu-bar-button
      [variant]="'outline'"
      [icon]="'fa-regular fa-file-xls'"
      [responsive]="true"
      tooltip="Exportieren"
      (execute)="onExportTicket()"
    ></soft-menu-bar-button>
    @if (!this.ticketConfig.isCustomer) {
      <soft-menu-bar-button
        [variant]="'outline'"
        [icon]="'fa-regular fa-clipboard-check'"
        [responsive]="true"
        tooltip="Status setzen"
        [disabled]="!editorPermission()"
        (execute)="onSetTicketState()"
      ></soft-menu-bar-button>
      <soft-menu-bar-button
        [variant]="'danger'"
        [icon]="'fa-regular fa-arrows-rotate'"
        [responsive]="true"
        tooltip="Zurücksetzen"
        [disabled]="!editorPermission()"
        (execute)="onResetTicket()"
      ></soft-menu-bar-button>
      <soft-menu-bar-button
        [variant]="'danger'"
        [icon]="'fa-regular fa-trash'"
        [responsive]="true"
        tooltip="Ticket schließen"
        [disabled]="!editorPermission()"
        (execute)="onCloseTicket()"
      ></soft-menu-bar-button>
    }

  </div>
</ng-template>
